var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("HeaderLandingNew"),
      _vm._v(" "),
      _c("div", { staticClass: "section-one section-mobile-app" }, [
        _c("div", { staticClass: "so-content" }, [
          _c("h1", [_vm._v("Download MusicVerse")]),
          _vm._v(" "),
          _c("p", [_vm._v("Your one-stop app for sacred music.")]),
          _vm._v(" "),
          _c("div", { staticClass: "store-links" }, [
            _c(
              "a",
              {
                staticClass: "content-logo",
                attrs: {
                  href: _vm.appStoreUrl,
                  "aria-label": "App Store",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [
                _c("img", {
                  staticClass: "content-logo",
                  attrs: {
                    src: require("@/assets/applestore-logo.png"),
                    alt: "App Store"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "content-logo",
                attrs: {
                  href: _vm.googlePlayUrl,
                  "aria-label": "Google Play",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [
                _c("img", {
                  staticClass: "content-logo",
                  attrs: {
                    src: require("@/assets/googleplay-logo.png"),
                    alt: "Google Play"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "content-logo radius",
                attrs: {
                  href: _vm.appGalleryUrl,
                  "aria-label": "App Gallery",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [
                _c("img", {
                  staticClass: "content-logo radius",
                  attrs: {
                    src: require("@/assets/huawei-logo.png"),
                    alt: "App Gallery"
                  }
                })
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("FooterLandingNew")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e7eb5d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7eb5d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MobileApp.vue
// module id = null
// module chunks = 